// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".carousel-indicators[data-v-25404906]{left:50%;position:absolute;top:17rem;transform:translateX(-50%);z-index:2}.carousel-indicator-item[data-v-25404906]{background:#aaa;border:none;border-radius:50%;cursor:pointer;height:.8rem;margin:0 1rem;padding:0;width:.8rem}.active[data-v-25404906]{background:#222}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
